import { useNavigate } from "react-router-dom";
import "./Landing.css";
import logo from "../assets/General/logo.png";
import registerImg from "../assets/Landing/register.png";
import loginImg from "../assets/Landing/login.png";

export default function Landing() {
  const goToPage = useNavigate();

  return (
    <div className="landingpage">
      {/* these two empty divs are only for the background glow shapes */}
      <div className="landingGlow landingGlowOne" />
      <div className="landingGlow landingGlowTwo" />

      <img className="landingLogo" src={logo} alt="Explore Lanka Logo" />

      <div className="landingCard">
        <h1 className="landingTitle">Let’s Begin!</h1>
        <p className="landingSubtitle">
          Have you been here before, or is this your first adventure?
        </p>

        {/* each button sends the user to the correct start flow */}
        <div className="landingOptions">
          <button
            className="landingChoiceBtn big"
            onClick={() => goToPage("/register")}
          >
            <img src={registerImg} alt="Register" className="choiceImage" />
            <span className="choiceHeading">New Explorer</span>
            <span className="choiceDescription">
              Create a new explorer account
            </span>
          </button>

          <button
            className="landingChoiceBtn big secondary"
            onClick={() => goToPage("/login")}
          >
            <img src={loginImg} alt="Login" className="choiceImage" />
            <span className="choiceHeading">Continue Exploring</span>
            <span className="choiceDescription">
              Log in with your picture pattern
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}